export const isFR = (locale) => {
  return locale === "fr"
}
